function Error() {
    return (
      <p className="error">
        <span>💥</span> There was an error fecthing questions.
      </p>
    );
  }
  
  export default Error;
  